import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=0f447bbf&scoped=true"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"
import style0 from "./Domain.vue?vue&type=style&index=0&id=0f447bbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f447bbf",
  null
  
)

export default component.exports